export default (callBack, milliseconds, interval = 300, bodyClass = null) => {
    const start = Date.now();
    if (bodyClass) document.body.classList.add(bodyClass);
    const pollLoop = setInterval(() => {
        callBack();
        if (Date.now() - start > milliseconds) {
            if (bodyClass) document.body.classList.remove(bodyClass);
            clearInterval(pollLoop);
        }
    }, interval);
};
